import { FC, useEffect, useState } from "react";
import { useReUploadDocMutation } from "../../../generated/graphql";
import UploadFile from "../UploadFile/UploadFile";
import { useParams } from "react-router-dom";

interface IUploadFileAgain {
  uploadBtnText: string;
  docId: string | null | undefined;
  protocolNumber: string;
  name: string;
  submissionType: any;
}

const UploadFileAgain: FC<IUploadFileAgain> = (props): JSX.Element => {
  const { uploadBtnText, docId, protocolNumber, name, submissionType } = props;
  const [fileUrl, setFileUrl] = useState("");
  const { id } = useParams() as any;

  const [reUploadDoc, { data: uploadData, error, loading }] =
    useReUploadDocMutation();

  useEffect(() => {
    if (docId && fileUrl) {
      reUploadDoc({
        variables: {
          docId,
          fileUrl,
          submissionId: id,
          submissionType,
        },
      });
    }
  }, [fileUrl]);
  return (
    <UploadFile
      name={name}
      protocolNumber={protocolNumber}
      setUrl={setFileUrl}
      uploadBtnText={uploadBtnText}
    />
  );
};

export default UploadFileAgain;
